import React from 'react';
import { describe } from 'react-desc';
import PopperImpl from './PopperImpl.js';
export { Position as PopperPositions } from './positions.js';
export { Interaction as PopperInteractions } from './interaction.js';
import { popperProps, defaultProps } from './props.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/getComponentFromProps';
import '@elliemae/ds-utilities/reactTypesUtility';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-utilities/system';
import 'react-popper';
import 'memoize-one';
import './PopperContent.js';
import '@babel/runtime/helpers/esm/extends';
import 'react-spring/renderprops.cjs';
import '@elliemae/ds-overlay';
import './getArrowStylesBySize.js';

var DSPopper = function DSPopper(_ref) {
  var containerProps = _ref.containerProps,
      arrowGap = _ref.arrowGap,
      arrowSize = _ref.arrowSize,
      blockName = _ref.blockName,
      contentOffset = _ref.contentOffset,
      contentStyle = _ref.contentStyle,
      contentComponent = _ref.contentComponent,
      delayClose = _ref.delayClose,
      delayOpen = _ref.delayOpen,
      interactionType = _ref.interactionType,
      isOpen = _ref.isOpen,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      onPlacementChange = _ref.onPlacementChange,
      placement = _ref.placement,
      preventOverflow = _ref.preventOverflow,
      showArrow = _ref.showArrow,
      closeAnimationConfig = _ref.closeAnimationConfig,
      openAnimationConfig = _ref.openAnimationConfig,
      usePortal = _ref.usePortal,
      triggerComponent = _ref.triggerComponent,
      wrapExtraComponent = _ref.wrapExtraComponent,
      getTargetFromChildren = _ref.getTargetFromChildren,
      getContentFromChildren = _ref.getContentFromChildren,
      modifiers = _ref.modifiers,
      triggerRef = _ref.triggerRef,
      customPopper = _ref.children,
      renderReference = _ref.renderReference,
      referenceNode = _ref.referenceNode,
      zIndex = _ref.zIndex,
      hideIfNotVisible = _ref.hideIfNotVisible;
  return /*#__PURE__*/React.createElement(PopperImpl, {
    arrowGap: arrowGap,
    arrowSize: arrowSize,
    blockName: blockName,
    closeAnimationConfig: closeAnimationConfig,
    containerProps: containerProps,
    contentComponent: contentComponent,
    contentOffset: contentOffset,
    contentStyle: contentStyle,
    delayClose: delayClose,
    delayOpen: delayOpen,
    getContentFromChildren: getContentFromChildren,
    getTargetFromChildren: getTargetFromChildren,
    interactionType: interactionType,
    isOpen: isOpen,
    modifiers: modifiers,
    onOpen: onOpen,
    onClose: onClose,
    onPlacementChange: onPlacementChange,
    openAnimationConfig: openAnimationConfig,
    placement: placement,
    preventOverflow: preventOverflow,
    referenceNode: referenceNode,
    renderReference: renderReference,
    showArrow: showArrow,
    triggerComponent: triggerComponent,
    triggerRef: triggerRef,
    usePortal: usePortal,
    wrapExtraComponent: wrapExtraComponent,
    zIndex: zIndex,
    hideIfNotVisible: hideIfNotVisible
  }, customPopper);
}; // @deprecated: There's the NEW (not finished) popover that uses its own popper implementation.


DSPopper.propTypes = popperProps;
DSPopper.defaultProps = defaultProps;
var DSPopperWithSchema = describe(DSPopper);
DSPopperWithSchema.propTypes = popperProps;

export default DSPopper;
export { DSPopper, DSPopperWithSchema };
//# sourceMappingURL=DSPopper.js.map
